import { render, staticRenderFns } from "./SelfAssessmentPowerTest.vue?vue&type=template&id=1ed4db56&scoped=true&"
import script from "./SelfAssessmentPowerTest.vue?vue&type=script&lang=ts&"
export * from "./SelfAssessmentPowerTest.vue?vue&type=script&lang=ts&"
import style0 from "./SelfAssessmentPowerTest.vue?vue&type=style&index=0&id=1ed4db56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed4db56",
  null
  
)

export default component.exports